import expired from 'helpers/jwt/expired';
import { refreshTokenClientSide } from 'helpers/user/refreshToken';
import { getDispatcher } from 'store/store';
import { ACCESS_TOKEN, getClientSideCookie } from '../cookies';

const refreshJWT = async (config) => {
	let access_token = getClientSideCookie(ACCESS_TOKEN);

	if (!access_token || expired(access_token)) {
		const dispatch = getDispatcher();
		await refreshTokenClientSide({ dispatch });
	}

	return config;
};

export default refreshJWT;
